import { UserManager, User, WebStorageStateStore, SignoutResponse } from 'oidc-client';
import { Constants } from '../helpers/Constants';
import { setTokenExpiry } from './UtilService';

export class AuthService {
	public userManager: UserManager;
	constructor() {
		const oidcConfig = {
			authority: process.env.REACT_APP_AUTHORITY ? process.env.REACT_APP_AUTHORITY : '',
			client_id: process.env.REACT_APP_CLIENT_ID ? process.env.REACT_APP_CLIENT_ID: '',
			redirect_uri: process.env.REACT_APP_REDIRECT_URI ? process.env.REACT_APP_REDIRECT_URI : '',
			silent_redirect_uri: `${Constants.clientRoot}silent-renew.html`,
			post_logout_redirect_uri: `${Constants.clientRoot}`,
			response_type: 'code',
			scope: Constants.clientScope,
			client_secret: Constants.clientSecret,
			stateStore : new WebStorageStateStore({ store: window.localStorage }),
			userStore : new WebStorageStateStore({ store: window.localStorage }),
		};
		this.userManager = new UserManager(oidcConfig);
	}

	// Getter method to export the userManager
	public getUserManager(): UserManager {
        return this.userManager;
    }

	public getUser(): Promise<User | null>{
		return this.userManager.getUser();
	}

	public login(): Promise<void> {
		return  this.userManager.signinRedirect();
	}

	public renewToken(): Promise<User | null> {
        return this.userManager.signinSilent();
    }

	public signinRedirectCallback(): Promise<User | null>{
		return  this.userManager.signinRedirectCallback();
	}

	public signoutRedirectCallback(): Promise<SignoutResponse | null>{
		return this.userManager.signoutRedirectCallback();
	}

	public async getIDToken(){
		const current = new Date().getTime();
		const expiryAt = localStorage.getItem('tokenExpiryAt');
		if( expiryAt && Number(expiryAt) <= current){
			setTokenExpiry();
			const user = await this.userManager.signinSilent();
			return user && user.id_token ? user.id_token: null;
		}else{
			const user = await this.userManager.getUser();
			return user && user.id_token ? user.id_token: null;
		}
	}
}


const authService = (function () {
    let authServiceInstance: AuthService;
    function createAuthInstance() {
        return new AuthService();
    }
    return {
        getAuthInstance: function () {
            if (!authServiceInstance) {
                authServiceInstance = createAuthInstance();
            }
            return authServiceInstance;
        },
    };
})();

export const AuthServiceClass = authService.getAuthInstance();